import { Flex } from 'components/flex';
import { Icon } from 'components/icon';
import { ErrorColor, ErrorPadding } from 'types';
import { ErrorAlert } from 'components/error-alert';
import { useReceiptSupportQuery } from 'store/api/support';

import { refundedText, unresolvedText, replacementText } from './helpers';

// Read-only strips on a receipt for what Customer care did from the Support
// app (BUILD-SPEC §6.5): an unresolved refund (Do NOT refund it again), a
// refund done, a replacement sent. Nothing shows when there is nothing, when
// the connection isn't set up, or when the read fails: the receipt never
// waits on it.
export const SupportRefundStrip = ({ checkoutId }: { checkoutId?: number }) => {
  const { data } = useReceiptSupportQuery(checkoutId as number, {
    skip: !checkoutId,
  });

  if (!data) {
    return null;
  }
  const unresolved = data.requests.filter((r) => r.status === 'unresolved');
  const refunded = data.requests.filter((r) => r.status === 'completed');
  if (!unresolved.length && !refunded.length && !data.replacements.length) {
    return null;
  }

  return (
    <Flex column gap={8} data-testid="support-refund-strips">
      {unresolved.map((request) => (
        <ErrorAlert
          color={ErrorColor.Red}
          icon={<Icon.AlertError />}
          key={`u${request.requestId}`}
          padding={ErrorPadding.Default}
        >
          {unresolvedText(request)}
        </ErrorAlert>
      ))}
      {refunded.map((request) => (
        <ErrorAlert
          regularText
          icon={<Icon.CheckCircle />}
          color={ErrorColor.LightBlue}
          key={`r${request.requestId}`}
          padding={ErrorPadding.Default}
        >
          <span>{refundedText(request)}</span>
        </ErrorAlert>
      ))}
      {data.replacements.map((replacement) => (
        <ErrorAlert
          regularText
          icon={<Icon.Delivery />}
          color={ErrorColor.LightBlue}
          padding={ErrorPadding.Default}
          key={replacement.supportReplacementTicketId}
        >
          <span>{replacementText(replacement)}</span>
        </ErrorAlert>
      ))}
    </Flex>
  );
};
